const FILTER_TYPES = {
	RANGE: "range",
	SELECT: "select",
};

export default FILTER_TYPES;
